import Utils from './Utils';

/** This generates a basic error response when receiving and ajax error and rejecting a promise. */
function generateRejectResponse(reject) {
  return function(data, url, httpStatusCode) {
    let errorData = { message: "Ajax Error: " + httpStatusCode };
    errorData.response = data;
    errorData.url = url;
    errorData.httpStatusCode = httpStatusCode;
    if (data.message) errorData.message = data.message;

    reject(errorData);
  };
}

function post(url, data) {
  return new Promise((accept, reject) => {
    let payload = {
      url: url,
      type: 'POST',
      success: accept,
      error: generateRejectResponse(reject)
    };

    if (data) payload.data = data;
    Utils.ajax(payload);
  });
}

function get(url) {
  return new Promise((accept, reject) => {
    let payload = {
      url: url,
      type: 'GET',
      success: accept,
      error: generateRejectResponse(reject)
    };
    Utils.ajax(payload);
  });
}

function del(url) {
  return new Promise((accept, reject) => {
    let payload = {
      url: url,
      type: 'DELETE',
      success: accept,
      error: generateRejectResponse(reject)
    };
    Utils.ajax(payload);
  });
}

export default {
  post,
  get,
  delete: del
};



/** WEBPACK FOOTER **
 ** ./src/Api/ajax.js
 **/